var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLiveTrackingRgbRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "dhl_icons",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40,20V44H30V33H12.5L8,28.0908V16l4,4H24.8257C25.7553,21.6235,30,29.0151,30,29.0151S34.2448,21.6235,35.1743,20ZM11.5,35,8,31.1113V40l4,4H28V35ZM23.7,13.9775a7.067,7.067,0,0,1-.4276-1.1474A6.9075,6.9075,0,0,1,30,4a7.0181,7.0181,0,0,1,7,7,6.8227,6.8227,0,0,1-.2728,1.83A7.0763,7.0763,0,0,1,36.3,13.9775C36.143,14.3062,30,25,30,25S23.857,14.3062,23.7,13.9775ZM27,11a3,3,0,0,0,6,0,3,3,0,0,0-6,0Z",
    fill: "#d70511"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLiveTrackingRgbRed);
export default __webpack_public_path__ + "static/media/live_tracking_rgb_red.ef08e5ddec306b3dceb51fc2ff3db7f6.svg";
export { ForwardRef as ReactComponent };